<template>
    <div class="login">
        <div class="content">
            <div class="info" style="cursor: default">
                <div class="logo">
                    <img
                        alt="Weeduc"
                        src="@/assets/Weflix/Weflix-Logo-Total-Branco.png"
                        style="width: 200px"
                        v-show="isWeflix"
                    />
                    <img
                        alt="Weeduc"
                        src="@/assets/logo_white.png"
                        style="width: 200px"
                        v-show="isWeeduc"
                    />
                </div>
                <div class="company" v-show="numberSites > 1 && !showTwoFactor">
                    <h4 class="form-title">
                        {{ $t('auth.helloUser', { name: userName }) }}
                    </h4>
                    <p class="form-subtitle">{{ $t('auth.whatToAccess') }}</p>

                    <div class="company-field">
                        <label for="company-search" class="form-label">
                            {{ $t('auth.company') }}
                        </label>
                        <div class="company-search">
                            <input
                                id="company-search"
                                v-model="filterText"
                                type="search"
                                class="form-control"
                                :placeholder="$t('auth.searchCompany')"
                                autocomplete="off"
                                @keydown.enter.prevent="onCompanySearchEnter"
                            />
                            <fa
                                icon="fa-solid fa-magnifying-glass"
                                class="company-search__icon"
                            />
                        </div>
                    </div>

                    <ul class="company-list" role="listbox">
                        <li
                            v-for="site in filteredSites"
                            :key="site.id || site.url || site.nome"
                        >
                            <button
                                type="button"
                                class="company-option"
                                :class="{
                                    selected: isCompanySelected(site),
                                    weflix:
                                        typeSystemLocal == 1 ||
                                        typeSystemLocal == 2,
                                }"
                                role="option"
                                :aria-selected="isCompanySelected(site)"
                                @click="selectCompany(site)"
                                @dblclick="accessSelectedCompany"
                            >
                                <span class="company-option__name">{{
                                    site.nome
                                }}</span>
                                <span
                                    class="company-option__check"
                                    aria-hidden="true"
                                ></span>
                            </button>
                        </li>
                        <li v-if="!filteredSites.length" class="company-empty">
                            {{ $t('auth.noCompanyFound') }}
                        </li>
                    </ul>

                        <div class="erro" v-show="erroLgin">
                            <small>{{ mensageErro }}</small>
                        </div>

                        <div class="mb-4 text-center company-actions">
                        <button
                            type="button"
                            class="btn-success"
                            :class="{
                                weflix:
                                    typeSystemLocal == 1 ||
                                    typeSystemLocal == 2,
                            }"
                            :disabled="!selectedCompany"
                            @click="accessSelectedCompany"
                        >
                            {{ $t('auth.access') }}
                        </button>
                    </div>
                    <div class="mb-3 company-back">
                        <button
                            type="button"
                            class="forgot-password-link"
                            :class="{ weflix: typeSystemLocal == 2 }"
                            @click="goBackToLogin"
                        >
                            {{ $t('auth.backToLogin') }}
                        </button>
                    </div>
                </div>
  
                <TwoFactorStep
                    v-if="showTwoFactor"
                    :variant="usesWeflixButton ? 'weflix' : 'admin'"
                    :email="twoFactorEmail"
                    :method="twoFactorMethod"
                    :otpauth-uri="otpauthUri"
                    :busy="twoFactorBusy"
                    :error="twoFactorError"
                    :resent="twoFactorResent"
                    @continue="continueAfterTwoFactor"
                    @choose="chooseTwoFactorMethod"
                    @resend="resendTwoFactorCode"
                    @back="cancelTwoFactor"
                />

                <div class="form" v-show="numberSites == 1 && !showTwoFactor">
                    <form @submit.prevent="handleSubmit" class="form">
                        <h4 class="form-title">{{ $t('auth.loginTitle') }}</h4>
                        <p class="form-subtitle">{{ $t('auth.loginSubtitle') }}</p>
  
                        <div class="mb-3">
                            <label for="email" class="form-label">{{ $t('auth.email') }}</label>
                            <input
                                type="email"
                                v-model="email"
                                class="form-control"
                                id="email"
                                required
                                :placeholder="$t('auth.emailPlaceholder')"
                            />
                        </div>

                        <div class="mb-3 password">
                            <label for="password" class="form-label">{{ $t('auth.password') }}</label>
                            <input
                                v-model="password"
                                :type="showPassword"
                                class="form-control"
                                id="password"
                                required
                                :placeholder="$t('auth.passwordPlaceholder')"
                            />
                            <fa
                                icon="eye"
                                style="cursor: pointer"
                                v-show="showPassword == 'text'"
                                @click="changeViewPassword()"
                            />
                            <fa
                                icon="eye-slash"
                                style="cursor: pointer"
                                v-show="showPassword == 'password'"
                                @click="changeViewPassword()"
                            />
                        </div>

                        <div class="mb-3 forgot_password">
                            <a
                                href="/esqueci-senha"
                                :class="{ weflix: typeSystemLocal == 2 }"
                                class="forgot-password-link"
                            >
                                {{ $t('auth.forgotPassword') }}
                            </a>
                        </div>
  
                        <div class="erro" v-show="erroLgin">
                            <small>{{ mensageErro }}</small>
                        </div>
  
                        <div class="mb-4 text-center" style="margin-top: 32px;">
                            <button
                                type="submit"
                                class="btn-success"
                                :class="{
                                    weflix: typeSystemLocal == 1 || typeSystemLocal == 2,
                                }"
                            >
                                {{ $t('auth.login') }}
                            </button>
                            <RecaptchaNotice />
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="login-version">
            <AppVersionLabel product="weeduc" />
        </div>
    </div>
  </template>

<script>
    import { mapState, mapActions } from 'vuex';
    import loginApi from '@/utils/login.js';
    import userApi from '@/utils/user.js';
    import ApiWeflix from '@/utils/Weflix/Website/index.js';
    import { toast } from 'vue3-toastify';
    import {
        resolveModeHome,
        syncAdminModeFromTypeBusiness,
    } from '@/utils/corporate/adminDashboardMode';
    import { isAdminUserType } from '@/utils/corporate/typeBusiness';
    import { getRecaptchaToken } from '@/utils/recaptcha';
    import RecaptchaNotice from '@/components/RecaptchaNotice.vue';
    import TwoFactorStep from '@/components/Auth/TwoFactorStep.vue';
    import AppVersionLabel from '@/components/AppVersionLabel.vue';
    import { isRateLimited } from '@/utils/rateLimit';

    export default {
        components: { RecaptchaNotice, TwoFactorStep, AppVersionLabel },
        data() {
            return {
                email: '',
                password: '',
                typeIdLocal: null,
                users: null,
                credentials: null,
                token: null,
                websites: null,
                refreshToken: null,
                idUser: null,
                showPassword: 'password',
                lististes: null,
                numberSites: 1,
                logo: null,
                selectedCompany: null,
                darkMode: null,
                userName: null,
                erroLgin: false,
                rateLimited: false,
                weflixPageLogin: false,
                typeSystemLocal: 1,
                baseUrl:
                    process.env.NODE_ENV === 'development'
                        ? process.env.VUE_APP_BASE_URL_HOMOLOGATION
                        : window.location.origin,

                filterText: '',
                showTwoFactor: false,
                challengeToken: '',
                twoFactorEmail: '',
                twoFactorMethod: 'email',
                otpauthUri: '',
                twoFactorError: '',
                twoFactorBusy: false,
                twoFactorResent: false,
                pendingDomainIndex: null,
            };
        },
        computed: {
            ...mapState(['typeId', 'numberIntensTable', 'typeSystem', 'dark']),
            mensageErro() {
                return this.$t(this.rateLimited ? 'auth.tooManyAttempts' : 'auth.loginError');
            },
            filteredSites() {
                if (!this.lististes) {
                    return [];
                }
                const filter = (this.filterText || '').trim().toUpperCase();
                if (!filter) {
                    return this.lististes;
                }
                return this.lististes.filter(
                    (site) =>
                        site &&
                        site.nome &&
                        site.nome.toUpperCase().includes(filter)
                );
            },
            isWeflix() {
                return Number(this.typeSystemLocal) === 2;
            },
            usesWeflixButton() {
                const type = Number(this.typeSystemLocal);
                return type === 1 || type === 2;
            },
            isWeeduc() {
                return Number(this.typeSystemLocal) !== 2;
            },
        },
        methods: {
            ...mapActions([
                'storeTypeId',
                'login',
                'storeToken',
                'storeWebsites',
                'storeRefreshToken',
                'storeUser',
                'toggleDarkMode',
                'storeNumberIntensTable',
                'storeTypeSystem',
                'storeCompanys',
                'restoreDarkMode',
            ]),
            changeViewPassword() {
                if (this.showPassword == 'password') {
                    this.showPassword = 'text';
                } else {
                    this.showPassword = 'password';
                }
            },
            async captchaToken() {
                const recaptchaToken = await getRecaptchaToken(this, 'login_admin');
                if (!recaptchaToken) {
                    this.erroLgin = true;
                    return null;
                }
                return recaptchaToken;
            },
            async fetchUsers() {
                try {
                    const recaptchaToken = await this.captchaToken();
                    if (!recaptchaToken) {
                        return;
                    }
                    const response = await loginApi.token(
                        {
                            email: this.email,
                            password: this.password,
                            recaptchaToken,
                        },
                        {
                            withCredentials: false,
                        }
                    );
                    await this.consumeAuthPayload(response.data, null);
                } catch (error) {
                    this.rateLimited = isRateLimited(error);
                    this.erroLgin = true;
                    console.error('Error fetching API:', error);
                }
            },
            async getTokenManyCompany(index) {
                try {
                    if (!this.lististes || !this.lististes[index]) {
                        console.error(
                            'Invalid index or lististes not initialized'
                        );
                        return;
                    }

                    if (this.token) {
                        const response = await loginApi.redirectCompany(
                            this.token,
                            this.lististes[index].url
                        );
                        await this.applyCompanySession(response.data);
                        return;
                    }
                    const recaptchaToken = await this.captchaToken();
                    if (!recaptchaToken) {
                        return;
                    }
                    const response = await loginApi.token(
                        {
                            email: this.email,
                            password: this.password,
                            domain: this.lististes[index].url,
                            recaptchaToken,
                        },
                        {
                            withCredentials: false,
                        }
                    );
                    await this.consumeAuthPayload(response.data, index);
                } catch (error) {
                    this.rateLimited = isRateLimited(error);
                    this.erroLgin = true;
                    console.error('Error fetching API:', error);
                }
            },
            async fetchUserData(id, tokenAPI, typeSystem) {
                try {
                    const userData = await userApi.getDataUser(id, tokenAPI);
                    this.storeUser({ user: userData });
                    this.handleRedirect(userData.type, typeSystem);
                } catch (error) {
                    console.error('Erro ao obter dados do usuário:', error);
                }
            },
            openTwoFactorChallenge(data) {
                this.challengeToken = data.challengeToken;
                this.twoFactorEmail = data.twoFactorEmail || this.email;
                this.twoFactorMethod = data.twoFactorMethod || 'email';
                this.otpauthUri = data.otpauthUri || '';
                this.twoFactorError = '';
                this.twoFactorResent = false;
                this.showTwoFactor = true;
            },
            async chooseTwoFactorMethod(method) {
                this.twoFactorBusy = true;
                this.twoFactorError = '';
                try {
                    const response = await loginApi.chooseTwoFactorMethod({
                        challengeToken: this.challengeToken,
                        method,
                    });
                    this.openTwoFactorChallenge(response.data);
                } catch (error) {
                    this.twoFactorError = this.twoFactorFailureMessage(error);
                } finally {
                    this.twoFactorBusy = false;
                }
            },
            async consumeAuthPayload(data, domainIndex) {
                if (loginApi.isTwoFactorChallenge(data)) {
                    this.pendingDomainIndex = domainIndex;
                    this.openTwoFactorChallenge(data);
                    return;
                }
                this.showTwoFactor = false;
                this.pendingDomainIndex = null;
                if (domainIndex == null) {
                    await this.applyDiscoveredSession(data);
                    return;
                }
                await this.applyCompanySession(data);
            },
            async applyDiscoveredSession(data) {
                if (!data?.user) {
                    this.erroLgin = true;
                    return;
                }
                this.userName = data.user.name;
                if (!isAdminUserType(data.user.type)) {
                    this.rejectPortalUser();
                    return;
                }
                if (data.acessToken) {
                    this.token = data.acessToken;
                    this.refreshToken = data.refreshToken;
                    this.storeToken({ token: this.token });
                    this.storeRefreshToken({ refreshToken: this.refreshToken });
                }
                const sites = data.listWebsite || [];
                if (sites.length > 1) {
                    this.storeCompanys({ companys: sites });
                    this.numberSites = sites.length;
                    this.lististes = sites;
                    this.selectedCompany = null;
                    this.filterText = '';
                    return;
                }
                this.lististes = sites;
                if (sites.length === 1) {
                    await this.getTokenManyCompany(0);
                    return;
                }
                if (data.acessToken) {
                    await this.applyCompanySession(data);
                } else {
                    this.erroLgin = true;
                }
            },
            async applyCompanySession(data) {
                if (!data?.acessToken || !data?.user) {
                    this.erroLgin = true;
                    return;
                }
                this.token = data.acessToken;
                this.typeIdLocal = data.type;
                this.refreshToken = data.refreshToken;
                this.idUser = data.user.id;
                this.websites = (data.listWebsite && data.listWebsite[0]) || this.websites;
                const typeSystem = Number(data.typeSystem);
                this.typeSystemLocal = typeSystem;
                this.storeTypeSystem({ typeSystem });
                this.setItemStorage();
                this.storeToken({ token: this.token });
                this.storeRefreshToken({ refreshToken: this.refreshToken });
                this.storeTypeId({ typeId: this.typeIdLocal });
                this.storeWebsites({ websites: this.websites });
                syncAdminModeFromTypeBusiness(this.websites);
                await this.fetchUserData(this.idUser, this.token, typeSystem);
                const savedDarkMode = localStorage.getItem('weeduc_dark_mode');
                if (savedDarkMode !== null) {
                    this.restoreDarkMode();
                } else {
                    this.toggleDarkMode(false);
                }
            },
            twoFactorFailureMessage(error) {
                if (isRateLimited(error)) return this.$t('auth.tooManyAttempts');
                return this.$t('auth.twoFactorInvalid');
            },
            async continueAfterTwoFactor(code) {
                this.twoFactorBusy = true;
                this.twoFactorError = '';
                this.twoFactorResent = false;
                try {
                    const response = await loginApi.verifyTwoFactor({
                        challengeToken: this.challengeToken,
                        code,
                    });
                    const domainIndex = this.pendingDomainIndex;
                    await this.consumeAuthPayload(response.data, domainIndex);
                } catch (error) {
                    this.twoFactorError = this.twoFactorFailureMessage(error);
                    console.error('Erro ao concluir o login em duas etapas:', error);
                } finally {
                    this.twoFactorBusy = false;
                }
            },
            async resendTwoFactorCode() {
                this.twoFactorBusy = true;
                this.twoFactorError = '';
                this.twoFactorResent = false;
                try {
                    const response = await loginApi.resendTwoFactor(this.challengeToken);
                    if (response?.data?.challengeToken) {
                        this.challengeToken = response.data.challengeToken;
                    }
                    this.twoFactorResent = true;
                } catch (error) {
                    this.twoFactorError = this.twoFactorFailureMessage(error);
                } finally {
                    this.twoFactorBusy = false;
                }
            },
            handleSubmit() {
                this.erroLgin = false;
                this.rateLimited = false;
                this.showTwoFactor = false;
                this.fetchUsers();
            },
            cancelTwoFactor() {
                this.showTwoFactor = false;
                this.challengeToken = '';
                this.twoFactorMethod = 'email';
                this.otpauthUri = '';
                this.pendingDomainIndex = null;
                this.twoFactorError = '';
                this.twoFactorResent = false;
            },
            isCompanySelected(site) {
                if (!this.selectedCompany || !site) {
                    return false;
                }
                if (this.selectedCompany === site) {
                    return true;
                }
                if (site.id && this.selectedCompany.id) {
                    return site.id === this.selectedCompany.id;
                }
                return site.url === this.selectedCompany.url;
            },
            selectCompany(site) {
                this.selectedCompany = site;
            },
            onCompanySearchEnter() {
                if (!this.selectedCompany && this.filteredSites.length === 1) {
                    this.selectedCompany = this.filteredSites[0];
                }
                this.accessSelectedCompany();
            },
            accessSelectedCompany() {
                if (!this.selectedCompany || !this.lististes) {
                    return;
                }
                const index = this.lististes.findIndex((site) =>
                    this.isCompanySelected(site)
                );
                if (index < 0) {
                    return;
                }
                this.getTokenManyCompany(index);
            },
            goBackToLogin() {
                this.numberSites = 1;
                this.selectedCompany = null;
                this.filterText = '';
                this.showTwoFactor = false;
            },
            setItemStorage() {
                localStorage.setItem('logado', 'true');
            },

            rejectPortalUser() {
                toast.error(this.$t('auth.portalUsersMustUsePortal'));
                this.$router.push('/portal');
            },
            handleRedirect(typeId, typeSystem) {
                if (!isAdminUserType(typeId)) {
                    this.rejectPortalUser();
                    return;
                }
                if (Number(typeSystem) === 1) {
                    const home = resolveModeHome(syncAdminModeFromTypeBusiness(this.websites));
                    this.$router.push({ path: home });
                    return;
                }
                this.$router.push({ path: '/admin/painel' });
            },

            setNumberItensPageOnLoad() {
                if (window.innerHeight > 680) {
                    this.storeNumberIntensTable({ numberIntensTable: 8 });
                } else if (
                    window.innerHeight < 650 &&
                    window.innerHeight > 450
                ) {
                    this.storeNumberIntensTable({ numberIntensTable: 5 });
                } else {
                    this.storeNumberIntensTable({ numberIntensTable: 4 });
                }
            },

            async getLogo() {
                let aux;
                
                // Verifica se é localhost e usa a URL do .env
                if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
                    aux = process.env.VUE_APP_BASE_URL_HOMOLOGATION;
                } else {
                    aux = this.baseUrl.replace(/\/$/, '');
                }
                console.debug(aux);

                const url = aux.split('/login')[0];
                const obj = { url: url };
                try {
                    const response = await loginApi.logo(obj);
                    this.logo = 'https://image.weeduc.com/' + response.logo;
                    if (!this.token) {
                        this.typeSystemLocal = response.typeSystem;
                    }
                } catch (error) {
                    console.error('Error fetching API:', error);
                }
            },
        },
        mounted() {
            this.setNumberItensPageOnLoad();
            this.getLogo();
        },
    };
</script>

<style scoped>
    .item {
        border: none;
    }
    .action {
        display: flex;
        justify-content: end;
        padding: 15px 0 5px;
    }
    .form {
        max-width: 100%;
        margin: 0;
        text-align: left;
        min-height: auto;
        position: relative;
    }
    .login {
        height: 100vh;
        display: flex;
        position: relative;
        background-image: url('@/assets/Weflix/bg-login-weflix.png');
        background-size: cover;
    }
    .login-version {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 20px;
        text-align: center;
        color: rgba(255, 255, 255, 0.88);
        pointer-events: none;
    }
    .login.weflix {
        height: 100vh;
        display: flex;
        background-image: url('@/assets/Weflix/bg-login-weflix.png');
        background-size: cover;
    }
    .mb-5.text-center.btn {
        width: 100%;
        position: absolute;
        bottom: 0;
    }
    .logo {
        display: flex;
        justify-content: center;
        margin: 20px;
        margin-top: -100px;
        margin-bottom: 40px;
        transform: translateY(-10px);
        filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    }
    .content {
        width: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
        gap: 10px;
    }
    .info {
        width: 450px;
        min-height: 500px;
        padding: 40px 30px;
        background-color: white;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
    }
    button.btn.btn-success {
        width: 100%;
        padding: 14px 24px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 12px;
        border: none;
        background: linear-gradient(135deg, #19c7d0 0%, #17a2b8 100%);
        color: white;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        box-shadow: 0 4px 15px rgba(25, 199, 208, 0.3);
    }
    button.btn.btn-success:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(25, 199, 208, 0.4);
        background: linear-gradient(135deg, #17a2b8 0%, #19c7d0 100%);
    }
    button.btn.btn-success:active {
        transform: translateY(0);
    }
    button.btn.btn-success:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
        box-shadow: 0 2px 8px rgba(25, 199, 208, 0.2);
    }
    .mb-3 {
        margin: 20px 0px;
    }
    .mb-3.forgot_password {
        color: red;
        margin: 0 !important;
        font-size: 11px;
        text-decoration: none;
        display: flex;
        justify-content: end;
    }
    .mb-3.forgot_password a {
        color: #19c7d0;
    }
    .mb-3.password {
        position: relative;
    }
    .mb-3.password i {
        position: absolute;
        top: 45px;
        right: 15px;
        color: #b4b4b4;
        cursor: pointer;
        transition: color 0.3s ease;
    }
    .mb-3.password i:hover {
        color: #19c7d0;
    }
    .form-control {
        border: 2px solid #e9ecef;
        border-radius: 12px;
        padding: 12px 16px;
        font-size: 16px;
        transition: all 0.3s ease;
        background-color: #f8f9fa;
    }
    .form-control:focus {
        border-color: #19c7d0;
        box-shadow: 0 0 0 0.2rem rgba(25, 199, 208, 0.25);
        background-color: white;
    }
    .form-control.is-invalid {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }
    .invalid-feedback {
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 0.875rem;
        color: #dc3545;
        font-weight: 500;
    }
    .form-control::placeholder {
        color: #adb5bd;
        font-size: 14px;
    }
    .company {
        max-width: 100%;
        margin: 0;
        text-align: left;
        position: relative;
        padding: 0;
    }
    .company-field {
        margin-bottom: 12px;
    }
    .company-field .form-control {
        margin-top: 0;
        padding-right: 42px;
    }
    .company-search {
        position: relative;
    }
    .company-search__icon {
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
        color: #adb5bd;
        font-size: 14px;
        pointer-events: none;
    }
    .company-list {
        list-style: none;
        margin: 0 0 8px;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-height: 240px;
        overflow-y: auto;
    }
    .company-list::-webkit-scrollbar {
        width: 6px;
    }
    .company-list::-webkit-scrollbar-thumb {
        background: #ced4da;
        border-radius: 8px;
    }
    .company-option {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        width: 100%;
        padding: 12px 16px;
        border: 2px solid #e9ecef;
        border-radius: 12px;
        background-color: #f8f9fa;
        color: #2c3e50;
        font-size: 15px;
        font-weight: 500;
        cursor: pointer;
        text-align: left;
        appearance: none;
        font-family: inherit;
        transition: all 0.3s ease;
    }
    .company-option:hover {
        border-color: #19c7d0;
        background-color: white;
    }
    .company-option:focus-visible {
        outline: none;
        border-color: #19c7d0;
        background-color: white;
        box-shadow: 0 0 0 0.2rem rgba(25, 199, 208, 0.25);
    }
    .company-option.selected {
        border-color: #19c7d0;
        background-color: white;
        box-shadow: 0 0 0 0.2rem rgba(25, 199, 208, 0.25);
    }
    .company-option.weflix:hover,
    .company-option.weflix.selected {
        border-color: #0d1a7e;
    }
    .company-option.weflix.selected {
        box-shadow: 0 0 0 0.2rem rgba(13, 26, 126, 0.2);
    }
    .company-option__name {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .company-option__check {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid #ced4da;
        background: white;
        position: relative;
        transition: all 0.2s ease;
    }
    .company-option.selected .company-option__check {
        border-color: #19c7d0;
        background: #19c7d0;
    }
    .company-option.weflix.selected .company-option__check {
        border-color: #0d1a7e;
        background: #0d1a7e;
    }
    .company-option.selected .company-option__check::after {
        content: '';
        position: absolute;
        left: 5px;
        top: 2px;
        width: 4px;
        height: 8px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
    .company-empty {
        padding: 16px;
        text-align: center;
        color: #6c757d;
        font-size: 14px;
        background-color: #f8f9fa;
        border-radius: 12px;
    }
    .company-actions {
        margin-top: 32px;
    }
    .company-actions .btn-success {
        width: 100%;
        padding: 14px 24px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 12px;
        border: none;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
    .company-back {
        display: flex;
        justify-content: center;
        margin: 0 !important;
    }
    .company-back .forgot-password-link {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
    }
    .option-company {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e0e0e0;
        padding: 12px 0;
    }
    .erro {
        margin: 16px 0;
        padding: 12px 16px;
        background-color: #f8d7da;
        border: 1px solid #f5c6cb;
        border-radius: 8px;
        animation: slideIn 0.3s ease;
    }
    .erro small {
        color: #721c24;
        font-weight: 500;
        font-size: 14px;
    }
    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    .form-title {
        text-align: center;
        margin-bottom: 8px;
        color: #2c3e50;
        font-weight: 700;
        font-size: 28px;
        letter-spacing: -0.5px;
    }
    .form-subtitle {
        text-align: center;
        margin-bottom: 32px;
        color: #6c757d;
        font-size: 16px;
        line-height: 1.5;
    }
    .form-label {
        font-weight: 600;
        color: #495057;
        margin-bottom: 8px;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
    .forgot-password-link {
        color: #19c7d0;
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;
        transition: all 0.3s ease;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }
    .forgot-password-link:hover {
        color: #17a2b8;
        text-decoration: none;
        transform: translateX(-2px);
    }
    .forgot-password-link.weflix {
        color: #0d1a7e;
    }
    .forgot-password-link.weflix:hover {
        color: #1a237e;
    }
    button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
    .option-company:last-child {
        border: none;
    }

    @media (max-width: 600px) {
        .info {
            width: 87%;
            min-height: 450px;
            padding: 30px 20px;
        }

        .logo {
            margin-top: -90px;
            margin-bottom: 30px;
        }
        .form {
            margin: 0px 10px;
            padding-bottom: 10px;
        }
        .option-company:last-child {
            border: none;
        }
        .company {
            max-width: 100%;
            margin: 0;
            padding: 0;
        }
        .company-list {
            max-height: 200px;
        }
        .mb-3 {
            margin: 12px 0px;
        }
    }
    svg.svg-inline--fa.fa-eye,
    svg.svg-inline--fa.fa-eye-slash {
        position: absolute;
        top: 45px;
        right: 5px;
        font-size: 15px !important;
        color: #dee2e6 !important;
    }
    button.btn-success.weflix {
        background: linear-gradient(135deg, #0d1a7e 0%, #1a237e 100%) !important;
        width: 100%;
        color: white;
        padding: 14px 24px;
        border-radius: 12px;
        box-shadow: 0 4px 15px rgba(13, 26, 126, 0.3);
    }
    button.btn-success.weflix:hover {
        background: linear-gradient(135deg, #1a237e 0%, #0d1a7e 100%) !important;
        box-shadow: 0 6px 20px rgba(13, 26, 126, 0.4);
    }
    a.weflix {
        color: #0d1a7e !important;
    }
    .dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #f9f9f9;
        min-width: 160px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        z-index: 1;
    }

    .dropdown-content a {
        color: black;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
    }

    .dropdown-content a:hover {
        background-color: #f1f1f1;
    }

    .dropdown:hover .dropdown-content {
        display: block;
    }

    .dropdown:hover .dropbtn {
        background-color: #3e8e41;
    }
    @media (max-width: 600px) {
        .info {
            width: 87%;
            padding: 10px;
        }
    }
</style>
